const laggards = {
  	index: 		r => require.ensure([], () => r(require('./components/laggards')), 'recipient-bundle'),
	edit: 	   r => require.ensure([], () => r(require('./components/edit')), 	'recipient-bundle'),
	LaggardsNew: 	 r => require.ensure([], () => r(require('./components/laggards_new')), 'recipient-bundle'),
 };


export default [
    {
		name: 'reports.laggards',
		path: '/reports/laggards',
		component: laggards.index,
    },
    {
		name: 'laggards.edit',
		path: '/laggards/:id',
		component: laggards.edit,
    },
    {
		name: 'laggards',
		path: '/laggards',
		component: laggards.LaggardsNew,
    },

]




// WEBPACK FOOTER //
// ./src/app/laggards/routes.js